export default "__VITE_ASSET__BOrc3K88__"